import { apolloClient } from "../../vue-apollo";
import {
    GET_TIPO_BENEFICIOS_EMPRESA,
    LISTAR_BENEFICIO,
    LISTA_BENEFICIO_USUARIO
} from "../../graphql/queries";
import { CREA_SOLICITUD_BENEFICIO } from "../../graphql/mutations";
export default {
    namespaced: true,
    state: { 
        tipoBeneficio: [],
        formularioBeneficio: [],
        checkEnvioSolicitud: null,
        listSolicitudes: []
    },
    mutations: {
        SET_TIPO_BENEFICIOS(state, tipos){
            state.tipoBeneficio = tipos;
        },
        SET_FORMULARIO_BENEFICIO(state, formulario){
            state.formularioBeneficio = formulario;
        },
        SET_ENVIO_SOLICITUD_BENEFICIO(state, solicitud){
            state.checkEnvioSolicitud = solicitud;
        },
        SET_SOLICITUDES_USUARIO(state, lista){
            state.listSolicitudes = lista;
        }

    },
    actions: {
    // obtener lita de tipos de solicitudes asociadas al cliente, para el caso de no tener devuelve un false 
        async getTipoBeneficio({commit}, data_){
            let response = [];
            let data = {};
            let params = {
            query: GET_TIPO_BENEFICIOS_EMPRESA,
            variables: data_,
            fetchPolicy: 'network-only'
            }
            try {
            await apolloClient.query(params).then(res => {
                if (!res.loading) data = res.data.TipoSolicitudes;
                response = data;
            });
            } catch(e) {
            //console.log("listar getTipoBeneficio falla: ", e);
            commit("SET_TIPO_BENEFICIOS", response);
            response = null
            }
            return new Promise((resolve)=>{
            if(response  != null){
                commit("SET_TIPO_BENEFICIOS", response);
                resolve(response)
            } else {
                commit("SET_TIPO_BENEFICIOS", response);
                resolve(null)
            }
            });
        },
        // obtener el formulario según tipo seleccionado, para el caso de no tener devuelve un false
        async getFormularioBeneficio({ commit }, data_){
            let response = [];
            let data = {};
            let params = {
            query: LISTAR_BENEFICIO,
            variables: data_,
            fetchPolicy: 'network-only'
            }
            try {
            await apolloClient.query(params).then(res => {
                if (!res.loading) data = res.data.ListarAllElementsTiposSolicitud;
                response = data;
            });
            } catch(e) {
                commit("SET_FORMULARIO_BENEFICIO", response);
            //console.log("listar getFormularioBeneficio falla: ", e);
            response = null
            }
            return new Promise((resolve)=>{
            if(response  != null){
                commit("SET_FORMULARIO_BENEFICIO", response);
                resolve(response)
            } else {
                commit("SET_FORMULARIO_BENEFICIO", response);
                resolve(null)
            }
            });
        },
        // Metodo obtiene lista de un tipo de solicitud realizada por un usuario
        /** metodo necesita los parametros  retorna un objeto completo del formulario si el proceso ocurrio corretamente, de ocurrir un falla 
         * retorna un false
         */
        async getBeneficiosObtenidosUser({ commit }, data_)
        {
            let response = [];
            let data = {};
            let params = {
            query: LISTA_BENEFICIO_USUARIO,
            variables: data_,
            fetchPolicy: 'network-only'
            }
            try {
                await apolloClient.query(params).then(res => {
                    //console.log("listar getFormularioBeneficio : ",res.data.ListSolicitudesUsuarios);
                    if (!res.loading) data = res.data.ListSolicitudesUsuarios;
                    response = data;
                });
            } catch(e) 
            {
                console.log("listar getBeneficiosObtenidosUser falla: ", e);
                commit("SET_SOLICITUDES_USUARIO", response);
                response = null
            }
            return new Promise((resolve)=>{
            if(response  != null){
                commit("SET_SOLICITUDES_USUARIO", response);
                resolve(true)
            } else {
                commit("SET_SOLICITUDES_USUARIO", response);
                resolve(false)
            }
            });
        },

        // Metodo crea una solicitud
        /** metodo necesita los parametros  retorna un objeto completo del formulario si el proceso ocurrio corretamente, de ocurrir un falla 
         * retorna un false
         */
        async crearSolicitudBeneficio({ commit }, data_){
            let response = null;
            let data = [];
            let params = {
                mutation: CREA_SOLICITUD_BENEFICIO,
                variables: data_
            }
            try{
                await apolloClient.mutate(params).then(res=>{
                    console.log('crearSolicitudBeneficio', res.data.GuardarSolicitudUsuarioObjeto);
                    if (!res.loading) data = res.data.GuardarSolicitudUsuarioObjeto;
                    response = data;
                });
            }
            catch(e){
                console.log("Falla metodo crearSolicitudBeneficio: ", e);
                commit("SET_ENVIO_SOLICITUD_BENEFICIO", response);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    resolve(response);
                    commit("SET_ENVIO_SOLICITUD_BENEFICIO", response);
                }
                else {
                    commit("SET_ENVIO_SOLICITUD_BENEFICIO", response);
                    resolve(false);
                }
            });
        }
    },
    getters: {

    },
};
